import CheckIcon from '@heroicons/react/outline/CheckIcon'
import LockClosedIcon from '@heroicons/react/outline/LockClosedIcon'
import startCase from 'lodash/startCase'

import { PlanName } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Badge, BadgeProps } from '@tribeplatform/react-ui-kit/Badge'

type PlanBadgeProps = BadgeProps & {
  requiredPlanName: PlanName
  authorized: boolean
  size?: 'lg' | 'md' | 'sm'
}

export const PlanBadge = (props: PlanBadgeProps) => {
  const { requiredPlanName, authorized, size = 'lg' } = props
  const { data: network } = useNetwork()
  const plan = network?.subscriptionPlan

  if (authorized && !plan?.trial) return null

  return (
    <Badge
      leadingIcon={authorized ? <CheckIcon /> : <LockClosedIcon />}
      rounded
      size={size}
      variant={authorized ? 'primary' : 'secondary'}
      {...props}
    >
      {startCase(requiredPlanName)} Plan
    </Badge>
  )
}
